export default __webpack_public_path__ + "static/moon-3cbb4e3e89450c9e17876c4e8433d421.webp";